import { render, staticRenderFns } from "./TagShow.vue?vue&type=template&id=da0b69f2&scoped=true"
import script from "./TagShow.vue?vue&type=script&lang=js"
export * from "./TagShow.vue?vue&type=script&lang=js"
import style0 from "./TagShow.vue?vue&type=style&index=0&id=da0b69f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0b69f2",
  null
  
)

export default component.exports